import React, { memo, useCallback } from 'react';
import SelectField from '../SelectField';
import MultiSelectField from './MultiSelectField';

// Componente para campos de selección única
const SelectOneField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  // Si tiene catalogReference, usar SelectField, sino usar select tradicional
  if (question.catalogReference) {
    return (
      <SelectField
        field={question}
        value={value}
        onChange={(name, newValue) => onChange(newValue)}
        error={error}
        readonly={readonly}
      />
    );
  }

  return (
    <select
      id={question.name}
      value={value || ''}
      onChange={handleChange}
      required={question.required}
      className={error ? 'has-error' : ''}
      disabled={readonly}
    >
      <option value="">Seleccione una opción</option>
      {question.choices && question.choices.map((choice, index) => (
        <option key={choice.name || index} value={choice.name || choice}>
          {choice.label || choice.name || choice}
        </option>
      ))}
    </select>
  );
});

// Componente para campos de selección múltiple
const SelectMultipleField = memo(({ question, value, onChange, error, readonly }) => {
  // Si tiene catalogReference, usar MultiSelectField, sino usar checkboxes tradicionales
  if (question.catalogReference) {
    return (
      <MultiSelectField
        field={question}
        value={value}
        onChange={(name, newValue) => onChange(newValue)}
        error={error}
        readonly={readonly}
      />
    );
  }

  return (
    <div className="checkbox-group">
      {question.choices && question.choices.map((choice, index) => {
        const choiceValue = choice.name || choice;
        const choiceLabel = choice.label || choice.name || choice;
        const isChecked = value && value.split(' ').includes(choiceValue);
        
        return (
          <label key={choiceValue || index} className="checkbox-item">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => {
                const currentValues = value ? value.split(' ') : [];
                let newValues;
                
                if (e.target.checked) {
                  newValues = [...currentValues, choiceValue];
                } else {
                  newValues = currentValues.filter(v => v !== choiceValue);
                }
                
                onChange(newValues.join(' '));
              }}
            />
            <span style={{ marginLeft: '8px' }}>{choiceLabel}</span>
          </label>
        );
      })}
    </div>
  );
});

SelectOneField.displayName = 'SelectOneField';
SelectMultipleField.displayName = 'SelectMultipleField';

export {
  SelectOneField,
  SelectMultipleField
};